import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { BootstrapSharedModule } from "../../../shared-modules/bootstrap-shared.module";
import { LoginComponent } from "./login.component";

const routes: Routes = [{ path: "", component: LoginComponent }];
const LoginRouting: ModuleWithProviders = RouterModule.forChild(routes);

@NgModule({
	imports: [CommonModule, FormsModule, LoginRouting, BootstrapSharedModule],
	declarations: [LoginComponent]
})
export class LoginModule { }
